import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { AxiosRequestConfig } from 'axios';
import { EndpointResponse } from '@/types/endpoints';
import { User } from '@/types/user';
import { utils } from '../../utils';

const validate = () => {};

export const getUser = async (
  scope: RequestScope,
  options: Pick<AxiosRequestConfig, 'operationRequirement' | 'signal'> = {}
): Promise<EndpointResponse<User>> => {
  try {
    validate();

    const result = await scopedApi(scope).get<EndpointResponse<User>>(`userprofile/me`, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
